import Icon from '../components/Icon.vue'

Icon.register({
  tshirt: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M631.2 96.5c7.9 3.9 11.1 13.6 7.1 21.5l-57.3 114.4c-4 8-13.6 11.2-21.5 7.2l-56.6-27.7c-10.6-5.2-23 2.6-23 14.4v253.7c0 17.7-14.3 32-32 32h-256c-17.7 0-32-14.3-32-32v-253.6c0-11.9-12.4-19.6-23-14.4l-56.6 27.7c-7.9 3.9-17.5 0.7-21.5-7.2l-57.2-114.5c-3.9-7.9-0.7-17.5 7.2-21.5l194.7-96.5c20.1 27.8 64.6 47.2 116.5 47.2s96.4-19.4 116.5-47.2z'
      }
    ]
  }
})
